<template>
<div class="tw-text-sm font-normal">
  <a class="tw-link" :href="`mailto:${ storeAnswer.data.value }`">
    {{ storeAnswer.data.value }}
  </a>
</div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>